import { render } from "./Hero.vue?vue&type=template&id=18e53c3b"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import exportComponent from "/Users/greg/sites/houston-landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/twig/components/hero/Hero.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18e53c3b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18e53c3b', __exports__)) {
    api.reload('18e53c3b', __exports__)
  }
  
  module.hot.accept("./Hero.vue?vue&type=template&id=18e53c3b", () => {
    api.rerender('18e53c3b', render)
  })

}


export default __exports__